export default __webpack_public_path__ + "static/media/identity-verification-woman.5bd918bf.jpg";